import { gql } from '@apollo/client'

export default gql`
  subscription GetLiveMonitorReaderParticipants($readingIds: [uuid!]!) {
    view_reading_room_participants(
      where: { reading_id: { _in: $readingIds } }
    ) {
      reading_id
      user_id
      person_name
      participationstate
      created
    }
  }
`
